import { useQuery } from 'react-query';
import User from '../models/User';

function useUserById(id?: string) {
    return useQuery<User>(['users', '/', id], { enabled: !!id, staleTime: 10000 });
}

export default useUserById;
